if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        // Más Limpiecito (móvil): la miniatura marcada sigue a la imagen principal en cuanto esta cambia de verdad, sin
        // la espera fija de 500 ms de Dawn. Mientras el dedo está apoyado no se cambia (sin selecciones intermedias);
        // al soltar, se marca la foto en la que se asienta el carrusel (evento scrollend; donde no existe, al soltar y
        // en cada cambio de foto durante la inercia).
        this.touching = false;
        this.elements.viewer.addEventListener('slideChanged', (event) => {
          if (!this.touching) this.onSlideChanged(event);
        });
        const slider = this.elements.viewer.slider;
        if (slider) {
          slider.addEventListener(
            'touchstart',
            () => {
              this.touching = true;
              this.prepareLoop();
            },
            { passive: true }
          );
          const release = () => {
            this.touching = false;
            if (!('onscrollend' in window)) this.syncThumbnail();
          };
          slider.addEventListener('touchend', release, { passive: true });
          slider.addEventListener('touchcancel', release, { passive: true });
          if ('onscrollend' in window)
            slider.addEventListener('scrollend', () => {
              if (this.touching) return;
              this.syncThumbnail();
              this.prepareLoop();
            });
        }
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
        if (this.mql.matches) this.initPreload();
      }

      // Más Limpiecito: en escritorio las fotos ocultas son lazy y solo se descargaban al hacer clic.
      // Se piden antes: al pasar el ratón o llevar el foco a su miniatura, y las dos siguientes cuando la página
      // queda desocupada (prioridad baja, después de la foto principal). Mismo srcset/sizes: el navegador elige
      // la resolución y reutiliza su caché. Una vez cargada una foto, no se vuelve a pedir.
      initPreload() {
        const warm = (img, priority) => {
          if (!img || img.complete || img.loading !== 'lazy') return;
          if (priority) img.fetchPriority = priority;
          img.loading = 'eager';
        };
        const photo = (mediaId) =>
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"] .product__modal-opener--image img`);
        const items = Array.from(this.elements.thumbnails.querySelectorAll('[data-target]'));
        items.forEach((item) => {
          const onIntent = () => warm(photo(item.dataset.target), 'high');
          item.addEventListener('pointerenter', onIntent, { once: true });
          item.addEventListener('focusin', onIntent, { once: true });
        });

        // Visor ampliado (no descarga mientras está cerrado): su foto se pide al acercar el ratón o el foco a la
        // foto principal; la de la primera foto, también en reposo.
        const modal = document.getElementById(this.id.replace('MediaGallery-', 'ProductModal-'));
        const warmModal = (mediaId, priority) => modal && warm(modal.querySelector(`img[data-media-id="${mediaId}"]`), priority);
        this.elements.viewer.querySelectorAll('.product__modal-opener--image').forEach((opener) => {
          const mediaId = opener.querySelector('.product__media-toggle')?.dataset.mediaId;
          const onIntent = () => warmModal(mediaId, 'high');
          opener.addEventListener('pointerenter', onIntent);
          opener.addEventListener('focusin', onIntent);
        });

        const idle = () => {
          items.slice(1, 3).forEach((item) => warm(photo(item.dataset.target), 'low'));
          const first = this.elements.viewer.querySelector('.is-active .product__media-toggle');
          if (first) warmModal(first.dataset.mediaId, 'low');
        };
        const whenIdle = () => ('requestIdleCallback' in window ? requestIdleCallback(idle, { timeout: 3000 }) : setTimeout(idle, 1500));
        if (document.readyState === 'complete') whenIdle();
        else window.addEventListener('load', whenIdle, { once: true });
      }

onSlideChanged(event) {
  if (!event.detail || !event.detail.currentElement) return;

  const mediaId = event.detail.currentElement.dataset?.mediaId;
  if (!mediaId) return;

  const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
  this.setActiveThumbnail(thumbnail);
}

      // la miniatura de la foto en la que está el carrusel ahora mismo
      syncThumbnail() {
        const viewer = this.elements.viewer;
        if (!viewer.sliderItemsToShow || !viewer.currentPage) return;
        const element = viewer.sliderItemsToShow[viewer.currentPage - 1];
        const thumbnail = element && this.elements.thumbnails.querySelector(`[data-target="${element.dataset.mediaId}"]`);
        if (!thumbnail || thumbnail.querySelector('button[aria-current]')) return;
        this.onSlideChanged({ detail: { currentElement: element } });
      }

      // Más Limpiecito (móvil): galería circular sin duplicar fotos. Si la foto a la vista es la primera o la última del
      // carrusel, la del extremo opuesto (la anterior o la siguiente en el círculo) pasa a ese lado y se compensa el
      // desplazamiento en el mismo instante: la imagen en pantalla no se mueve y el dedo puede seguir hacia ese lado.
      // Las miniaturas no cambian de orden (se emparejan por data-media-id).
      prepareLoop() {
        const viewer = this.elements.viewer;
        const slider = viewer.slider;
        if (!slider || this.mql.matches || !viewer.sliderItemOffset) return;
        const items = Array.from(viewer.sliderItems).filter((item) => item.clientWidth > 0);
        if (items.length < 3) return;
        const page = Math.round(slider.scrollLeft / viewer.sliderItemOffset);
        const last = items.length - 1;
        if (page > 0 && page < last) return;
        const current = items[Math.min(Math.max(page, 0), last)];
        const startLeft = slider.scrollLeft;
        const before = current.offsetLeft;
        if (page <= 0) items[0].before(items[last]);
        else items[last].after(items[0]);
        // posición absoluta (algunos navegadores ya reajustan el snap al mover la foto: no se suma dos veces)
        slider.style.scrollBehavior = 'auto';
        slider.scrollLeft = startLeft + current.offsetLeft - before;
        slider.style.scrollBehavior = '';
        viewer.resetPages();
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            // Más Limpiecito: al elegir una miniatura la foto principal aparece en el acto (el carrusel móvil tiene
            // scroll-behavior: smooth y tardaba 0,4–0,6 s según la distancia); el deslizamiento con el dedo no cambia
            const list = activeMedia.parentElement;
            list.style.scrollBehavior = 'auto';
            list.scrollTo({ left: activeMedia.offsetLeft });
            list.style.scrollBehavior = '';
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
